<template>
    <div class="pay_H">
      <el-container>
        <el-header style="height: 100px">
          <!-- <div>
            <div class="imgstop">
              <div class="imgstop_text">
                秋日
                <div>特惠</div>
                计划，低至
                <div>4折扣</div>
                ，流量送不停！
              </div>
            </div>
          </div> -->
          <Head> </Head>
        </el-header>
        <el-main class="pay_main_body">
          <div>
            <div class="sulutions_divA">
              <div class="sulutions_divA_div">
                <div class="sulutions_divA_div_H">静态数据中心代理</div>
                <div class="sulutions_divA_div_text">
                    奇迹ip静态数据中心代理，供个人独享使用的服务器IP，IP地址固定不变，支持长期使用同一个IP地址，保障业务运行不被中断
                </div>
                <div class="sulutions_divA_div_divS">
                  <div><i class="el-icon-success"></i>180万+IP池</div>
                  <div><i class="el-icon-success"></i>不限使用流量</div>
                  <div><i class="el-icon-success"></i>99.9%平均正常运行时间</div>
                </div>
                <div class="sulutions_divA_div_butts">
                  <div class="solu_butt_divA" @click="openWeChatChat()">免费试用</div>
                  <!--<div class="solu_butt_divB" @click="scrollToPurchase">产品价格</div>-->
                </div>
                <div class="sulutions_divA_div_but_text">
                  *注：所有类型IP仅支持在境外环境下使用
                </div>
              </div>
              <div>
                <img
                  src="http://apiupss.ppfly.top/images/banner_img1.svg"
                  alt=""
                />
              </div>
            </div>

            <div class="sulutions_divB">
              <div class="sulutions_divB_div">
                <div class="sulutions_divB_div_div_H">静态数据中心代理优势</div>
                <div class="sulutions_divB_div_div_B">
                  <div class="sulutions_div_top">
                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon1.svg"
                          alt=""
                        />
                      </div>

                      <div class="sulutions_divB_div_div_div_H">个人独享专用</div>
                      <div class="sulutions_divB_div_div_div_text">
                        个人专用的独享代理，灵活选择周、月、季度IP时长，支持根据业务定制时长
                      </div>
                    </div>

                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon2.svg"
                          alt=""
                        />
                      </div>

                      <div class="sulutions_divB_div_div_div_H">精准城市定位</div>
                      <div class="sulutions_divB_div_div_div_text">
                        全球地区资源任意选择，精准定位城市，根据指定的国家、城市、运营商获取所需IP
                      </div>
                    </div>

                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon3.svg"
                          alt=""
                        />
                      </div>

                      <div class="sulutions_divB_div_div_div_H">全协议支持</div>
                      <div class="sulutions_divB_div_div_div_text">
                        同时支持HTTP、HTTPS、Socks5协议，满足多种业务需求
                      </div>
                    </div>
                  </div>
                  <div class="sulutions_div_top">
                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon4.svg"
                          alt=""
                        />
                      </div>
                      <div class="sulutions_divB_div_div_div_H">
                        无限并发请求
                      </div>
                      <div class="sulutions_divB_div_div_div_text">
                        不限并发会话请求，不限制IP提取次数，不收取额外费用，有效降低业务成本
                      </div>
                    </div>
                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon5.svg"
                          alt=""
                        />
                      </div>

                      <div class="sulutions_divB_div_div_div_H">独享高带宽</div>
                      <div class="sulutions_divB_div_div_div_text">
                        代理服务器配置独享带宽，低延迟快速响应，业务高峰期也能平稳运行
                      </div>
                    </div>
                    <div class="sulutions_divB_div_div_div">
                      <div class="sulutions_divB_div_div_div_img">
                        <img
                          src="http://apiupss.ppfly.top/images/ys_icon6.svg"
                          alt=""
                        />
                      </div>

                      <div class="sulutions_divB_div_div_div_H">专属服务</div>
                      <div class="sulutions_divB_div_div_div_text">
                        商务+技术团队全程协助，提供产品和技术支持，7*24在线客服，实时提供帮助
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sulutions_divC">
              <div>
                <div class="sulutions_divC_div">
                  <div class="sulutions_divC_div_H">优选本地原生机房</div>
                  <div class="sulutions_divC_div_text">
                    优选全球本地原生机房，由高性能服务器IP组成的数据中心代理池，提供100多万个优质数据中心IP，覆盖全球国家地区
                  </div>
                  <div class="sulutions_divC_div_i">
                    <div class="sulutions_divC_div_i_div">
                      <div><i class="el-icon-check"></i>100+国家地区</div>
                      <div><i class="el-icon-check"></i>低延迟快速响应</div>
                    </div>
                    <div class="sulutions_divC_div_i_div">
                      <div><i class="el-icon-check"></i>业务级代理池</div>
                      <div><i class="el-icon-check"></i>根据业务定制方案</div>
                    </div>
                  </div>
                  <div class="sulutions_divC_div_butts">
                    <div class="div_div_butss" @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
                <div class="sulutions_divC_div_img">
                  <img
                    src="http://apiupss.ppfly.top/images/intro_li7.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- <div class="sulutions_divD">
              <div class="sulutions_divD_div">
                <div class="sulutions_divD_div_img">
                  <img
                    src="https://apiupss.ppfly.top/images/solution/intro_li5.svg"
                    alt=""
                  />
                </div>
                <div class="sulutions_divD_divs">
                  <div>运营商直采资源</div>
                  <div>
                    与全球各大运营商合作，直采纯净原生ISP资源，确保IP的真人住宅属性和高纯净度，满足跨境电商、社媒营销等各类高要求业务场景
                  </div>
                  <div>
                    全球100+国家地区资源，覆盖美洲、欧洲、亚洲主流国家及东南亚小众国家
                  </div>
                  <div class="div_div_butss">了解更多</div>
                </div>
              </div>
            </div> -->

            <div class="div_3">
              <div class="div_3_div">
                <div class="H2">热门国家地区</div>
                <div class="H3">我们提供更多的国家IP资源</div>
                <div class="num_gj">
                  <div>
                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_1.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">美国</div>
                        <div class="gj_img_H2">10,903,980个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_2.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">英国</div>
                        <div class="gj_img_H2">3,903,550个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_3.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">加拿大</div>
                        <div class="gj_img_H2">12,103,580个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_4.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">泰国</div>
                        <div class="gj_img_H2">804,671个IP</div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_5.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">印度尼西亚</div>
                        <div class="gj_img_H2">1,574,127个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_6.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">印度</div>
                        <div class="gj_img_H2">9,077,144个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_7.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">马来西亚</div>
                        <div class="gj_img_H2">584,675个IP</div>
                      </div>
                    </div>

                    <div class="gj_img">
                      <img
                        src="http://apiupss.ppfly.top/images/flag_8.svg"
                        alt=""
                      />
                      <div>
                        <div class="gj_img_H1">韩国</div>
                        <div class="gj_img_H2">453,980个IP</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="solut_div_A1">
              <div class="pay_main_body_divB_H1">应用场景</div>

              <div class="pay_main_body_divB_divs_link">
                <div>
                  <el-link
                    @click="onyycj('wysjcj')"
                    type="info"
                    :underline="false"
                    >网页数据采集</el-link
                  >
                </div>
                <div>
                  <el-link @click="onyycj('dzsw')" type="info" :underline="false"
                    >电子商务</el-link
                  >
                </div>
                <div>
                  <el-link @click="onyycj('scdc')" type="info" :underline="false"
                    >市场调查</el-link
                  >
                </div>
                <div>
                  <el-link @click="onyycj('SEOyh')" type="info" :underline="false"
                    >SEO优化</el-link
                  >
                </div>
                <div>
                  <el-link @click="onyycj('wzcs')" type="info" :underline="false"
                    >网站测试</el-link
                  >
                </div>
                <div>
                  <el-link
                    @click="onyycj('lyxxjh')"
                    type="info"
                    :underline="false"
                    >旅游信息聚合</el-link
                  >
                </div>
              </div>
              <div class="solut_divB1" v-if="wysjcj">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_1.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>网页数据采集</div>
                    <div>
                      掌握全球网络数据资源，从数千万网页中提取有价值的信息进行分析，为您的业务决策提供数据支持
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>

              <div class="solut_divB1" v-if="dzsw">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_8.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>电子商务</div>
                    <div>
                      从各大电商平台获取产品、关键词、价格、库存、评论等信息，掌握市场动态，提升自身产品竞争力
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>

              <div class="solut_divB1" v-if="scdc">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_5.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>市场调查</div>
                    <div>
                      挖掘市场研究的关键信息，帮助您更准确地洞察市场需求，预测市场变化趋势，占据行业优势
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>

              <div class="solut_divB1" v-if="SEOyh">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_9.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>SEO优化</div>
                    <div>
                      获取准确的搜索引擎结果数据，监控关键词、流量、排名变化，针对性制定SEO优化策略
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>

              <div class="solut_divB1" v-if="wzcs">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_3.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>网站测试</div>
                    <div>
                      帮助您时刻监控安全漏洞，全面优化网站性能，确保网站在不同地区和网络环境下稳定高效运行
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>

              <div class="solut_divB1" v-if="lyxxjh">
                <div class="solut_divB1_img_div">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/scene_10.svg"
                      alt=""
                    />
                  </div>
                  <div class="solut_divB1_img_div_div">
                    <div>旅游信息聚合</div>
                    <div>
                      实时追踪全球旅游动态，整合各大平台最新特价机票、酒店优惠等行业资讯，助您洞察行业趋势
                    </div>
                    <div @click="openWeChatChat()">了解更多</div>
                  </div>
                </div>
              </div>
            </div>

            <!--
            <div class="pay_main_body_divB">
              <div  ref="purchaseSection" class="pay_main_body_divB_H1">套餐购买</div>
              <div class="pay_main_body_divB_div">
                 <Pay_dxsjzx></Pay_dxsjzx>
              </div>
            </div>
            -->

            <div class="pay_main_body_divE">
              <div>
                <div class="but_Htext">常见问题</div>
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item
                    title="什么是独享数据中心代理？"
                    name="1"
                  >
                    <div class="collapse_text">
                        独享数据中心代理是专享的、长效的高性能服务器IP，IP地址可固定不变且具有更高的稳定性和网络速度。
                    </div>
                  </el-collapse-item>
                  <el-collapse-item
                    title="独享数据中心代理适用于哪些业务场景？"
                    name="2"
                  >
                    <div class="collapse_text">
                        适用于对IP时效、运行速度和稳定性有适用于对IP时效、运行速度和稳定性有更高要求的业务，如跨境电商、在线游戏、高频交易等。
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="独享数据中心代理是否纯净？会不会存在被污染或滥用的风险？" name="3">
                    <div class="collapse_text">
                        可以，奇迹ip可根据您对特定国家地区的需求，为您定制专属的IP资源。
                    </div>
                  </el-collapse-item>

                  <el-collapse-item
                    title="能否定制特定国家地区的IP？"
                    name="5"
                  >
                    <div class="collapse_text">
                        可以，奇迹ip可根据您对特定国家地区的需求，为您定制专属的IP资源。
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="独享数据中心代理支持哪些协议？" name="4">
                    <div class="collapse_text">
                        奇迹ip独享数据中心支持HTTP、HTTPS和SOCKS5协议。
                    </div>
                  </el-collapse-item>

                  <el-collapse-item
                    title="能否多设备同时使用同一IP？"
                    name="6"
                  >
                    <div class="collapse_text">
                        可以，您只需将团队成员或子账号的设备IP加入白名单，或通过账密认证管理子账号，即可实现多设备使用同一IP，轻松提高团队协作效率。
                    </div>

                  </el-collapse-item>


                </el-collapse>
              </div>
            </div>
          </div>

          <Footer></Footer>
        </el-main>
      </el-container>

      <Xuanfuret></Xuanfuret>
    </div>
  </template>

        <script>
  import Head from "@/components/head/head.vue";
  import Footer from "@/components/footer/footer.vue";
  import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
  import Pay_jtzz from "@/components/pay_/pay_jtzz.vue";
  import Pay_dxsjzx from "@/components/pay_/pay_dxsjzx.vue";
  export default {
    name: "home",
    components: { Head, Footer, Xuanfuret, Pay_jtzz, Pay_dxsjzx },
    data() {
      return {
        wysjcj: true,
        dzsw: false,
        scdc: false,
        SEOyh: false,
        wzcs: false,
        lyxxjh: false,
        IPsum: "",
        img_show: true,
        selectedLabels: [],
        selectedLabelsdata: [],
        selectedPackage: null,
        input3: "",
        // jingtaizhuzhai: true,
        duxiangsjzx: true,
        activeNames: "",
        isClickedA: false,
        isClickedB: false,
        isClickedC: false, // 用于跟踪按钮是否被点击
        edcz_div_show: false,
        cptc_div_show: true,
      };
    },
    computed: {},
    mounted() {},
    created() {
      // 在组件创建时获取路由参数
    },
    beforeDestroy() {},
    methods: {
      openWeChatChat() {
    },
      scrollToPurchase() {
      // 使用 Vue 的 $refs 获取目标元素并滚动到该元素
      const purchaseSection = this.$refs.purchaseSection;
      if (purchaseSection) {
        purchaseSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
      handleChange() {},
      onyycj(name) {
        if (name == "wysjcj") {
          this.wysjcj = true;
          this.dzsw = false;
          this.scdc = false;
          this.SEOyh = false;
          this.wzcs = false;
          this.lyxxjh = false;
        } else if (name == "dzsw") {
          this.wysjcj = false;
          this.dzsw = true;
          this.scdc = false;
          this.SEOyh = false;
          this.wzcs = false;
          this.lyxxjh = false;
        } else if (name == "scdc") {
          this.wysjcj = false;
          this.dzsw = false;
          this.scdc = true;
          this.SEOyh = false;
          this.wzcs = false;
          this.lyxxjh = false;
        } else if (name == "SEOyh") {
          this.wysjcj = false;
          this.dzsw = false;
          this.scdc = false;
          this.SEOyh = true;
          this.wzcs = false;
          this.lyxxjh = false;
        } else if (name == "wzcs") {
          this.wysjcj = false;
          this.dzsw = false;
          this.scdc = false;
          this.SEOyh = false;
          this.wzcs = true;
          this.lyxxjh = false;
        } else if (name == "lyxxjh") {
          this.wysjcj = false;
          this.dzsw = false;
          this.scdc = false;
          this.SEOyh = false;
          this.wzcs = false;
          this.lyxxjh = true;
        }
      },
    },
  };
  </script>
        <style scoped>
  .home_H {
    position: relative;
  }
  .el-icon-circle-close {
    font-size: 30px;
    color: #edf3fc;
  }

  .el-icon-arrow-down,
  .el-icon-user {
    font-weight: 600;
  }

  .el-header,
  .el-footer {
    color: #333;
    text-align: center;
    line-height: 60px;
    padding: 0;
  }

  .el-header {
    position: sticky;
    top: 0;
    background-color: #edf3fc;
    z-index: 5;
  }

  .imgstop_text {
    display: flex;
    justify-self: center;
    font-size: 25px;
    font-weight: 550;
    background-color: #edf3fc;
    width: 500px;
    margin: 0 auto;
  }
  .imgstop {
    width: 100%;
    height: 50px;
    background-image: url("../../assets/tops.png");
    background-size: cover;
  }

  .imgstop > div div {
    color: #6327d3;
  }

  .imgstop_text {
    display: flex;
    justify-self: center;
    font-size: 25px;
    font-weight: 550;
    background-color: #edf3fc;
    width: 500px;
    margin: 0 auto;
  }
  .pay_main_body {
    margin-top: 100px;
  }
  .pay_main_body_divA_div_H {
    font-size: 38px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    text-align: center;
    color: #1b2336;
    margin-top: 50px;
  }
  .pay_main_body_divA_div_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(27, 35, 54, 0.68);
    position: relative;
    width: max-content;
    margin: 16px auto 0;
  }
  .pay_main_body_divA_div_text_butts_divA {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 113px;
    height: 32px;
    z-index: 11;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    line-height: 32px;
  }
  .pay_main_body_divA_div_text_butts_divB {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 113px;
    height: 32px;
    z-index: 11;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    position: relative;
    border-radius: 20px;
    line-height: 32px;
  }
  .pay_main_body_divA_div_text_butts {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .pay_img_textA {
    display: flex;
    justify-content: space-between;
    width: 700px;
  }
  .pay_img_textA > div {
    letter-spacing: 1px;
    margin-left: 7px;
    font-size: 14px;
    color: #100043;
  }
  .pay_img_textA_img {
    margin-top: 5px;
  }
  .pay__div_img_textA {
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }
  .div_jiajian_butt {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .div_jiajian_buttB {
    display: flex;
    justify-content: left;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .div_jiajian_butt_text {
    border: none;
    background: transparent;
    font-size: 40px;
    line-height: 52px;
    height: 52px;
    font-weight: 600;
    color: #240009;
    padding-left: 20px;
    padding-right: 20px;
  }
  .div_jiajian_butt_textB {
    border: none;
    background: transparent;
    font-size: 40px;
    line-height: 52px;
    height: 52px;
    font-weight: 600;
    color: #240009;
    /* padding-left: 20px; */
    padding-right: 20px;
    text-align: left;
  }
  .div_jiajian_butt_A {
    width: 40px;
    height: 40px;
    margin-top: 5px;
  }
  .div_jiajian_butt_B {
    width: 40px;
    height: 40px;
    margin-top: 5px;
  }
  .pay_main_body_divB {
    margin-top: 100px;
  }
  .pay_main_body_divB_div_div_div {
    width: 262px;
    /* height: 480px; */
    padding-right: 20px;
    padding-left: 20px;
  }

  .pay_main_body_divB_div_div_div:hover .div_jiajian_butt_text {
    color: #6327d3;
  }
  .pay_main_body_divB_div_div_div_yhgm {
    transition: 0.4s;
    height: 52px;
    background: linear-gradient(90deg, #6327d3, #4a1e9b);
    box-shadow: 0 -2px 15px 0 #f3f3f3;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f1f2f4;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #edf3fc;
    margin: 19px auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    z-index: 2;
  }
  .pay_main_body_divB_div_div_div_div_span {
    display: flex;
    justify-content: right;
  }
  .pay_main_body_divB_div_div_div_div_span > span {
    background-color: #6e2e04;
    color: #edf3fc;
    /* padding: 5px; */
    line-height: 20px;
    border-radius: 15px;
    font-size: 15px;
    padding-right: 10px;
    padding-left: 10px;
  }
  .pay_main_body_divB_div_div_div_div_text {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #171a1f;
  }
  .pay_main_body_divB_div_div_div_div_textB {
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    color: #171a1f;
    text-align: left;
  }
  .jcdj {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1px;
  }
  .pay_main_body_divB_div_div {
    position: relative;
    /* min-height: 580px; */
    max-width: 1310px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    z-index: 0;
  }
  .pay_main_body_divB_div_divB {
    position: relative;
    /* min-height: 580px; */
    max-width: 1510px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    z-index: 0;
  }
  .dov_top {
    transition: 0.4s;
    padding-top: 20px;
  }
  .pay_main_body_divB_div_div_div:hover .dov_top {
    transform: translateY(-10px);
  }
  .pay_main_body_divB_div_div_div:hover .pay_main_body_divB_div_div_div_yhgm {
    background: linear-gradient(90deg, #ffffff, #ffffff);
    color: #6327d3;
    border: 1px solid #6327d3;
  }
  .pay_main_body_divC_div {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    position: relative;
    /* min-height: 580px; */
    max-width: 1480px;
    margin: 0 auto;
    z-index: 0;
    padding-right: 200px;
  }
  .pay_main_body_divC_div_ {
    width: 226px;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    cursor: pointer;
    position: relative;
  }
  .pay_main_body_divC_div_div:nth-child(odd) {
    color: #6327d3;
  }
  .pay_main_body_divC_div_ > div:nth-child(1) {
    width: 80%;
    font-size: 14px;
  }
  .pay_main_body_divC_div_ > div:nth-child(2) {
    width: 20%;
    font-size: 14px;
    text-align: right;
    white-space: nowrap;
    text-decoration: line-through; /* 添加删除线 */
  }
  .pay_main_body_divC_div_div {
    display: flex;
    justify-content: space-between;
  }
  .pay_main_body_divC_div_div:hover .div_li_showB {
    opacity: 1;
    width: 150px;
    transition: 0.4s;
  }
  .pay_main_body_divC_div_div:hover {
    color: #6327d3;
  }
  .pay_main_body_divC_div_div:hover .pay_main_body_divC_div_div_let {
    color: #6327d3;
  }
  .pay_main_body_divC_div_div:hover .el-icon-caret-right {
    color: #6327d3;
    opacity: 1;
  }

  .el-icon-caret-right {
    display: flex;
  }
  .pay_main_body_divC_div_div_let {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    width: 150px;
    text-align: left;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #170f49;
    display: flex;
    align-items: center;
  }
  .el-icon-caret-right {
    opacity: 0;
  }
  .div_li_showB {
    display: flex;
    justify-content: center;
    opacity: 0;
    font-size: 12px;
    width: 0px;
    border: 1px solid #6327d3;
    border-radius: 15px;
    position: absolute;
    left: 140px;
    background-color: #edf3fc;
    color: #6327d3;
  }
  .pay_main_body_divD_div {
    display: flex;
    justify-content: center;
  }
  .pay_main_body_divD_div_div {
    width: 1328px;
    height: 185px;
    display: flex;
    justify-content: space-around;
    background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
    padding: 30px;
    border-radius: 25px;
    margin-top: 100px;
  }
  .pay_main_body_divD_div_div_div_img {
    display: flex;
    justify-content: center;
    margin-top: 35px;
  }
  .but_div_ljdz > div {
    margin: 0 auto;
  }
  .but_div_ljdz {
    width: 174px;
    height: 50px;
    display: flex;
    align-items: center;
    color: #edf3fc;
    background: linear-gradient(90deg, #ffbe5c, #ff5a36);
    font-family: SourceHanSansCN-Regular;
    font-weight: 600;
    font-size: 17px;
    box-shadow: 0 4px 5.3px 0 rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    margin-top: 70px;
  }
  .dingzhi1V1 {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-right: 40px;
  }

  .dztc_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 600;
    font-size: 31px;
    color: #14171a;
    margin-left: 37px;
    margin-top: 40px;
  }
  .dingzhi1V1 > div {
    margin-right: 20px;
  }
  .dingzhi1V1_text {
    text-align: left;
    margin: 20px;
    font-size: 14px;
  }
  .pay_main_body_divE {
    display: flex;
    justify-content: center;
    margin-top: 600px;
  }
  .pay_main_body_divE > div {
    width: 1400px;
  }
  .collapse_text {
    text-align: left;
    color: #3194ce;
  }
  .but_Htext {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 38px;
    color: #1b2336;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .top_button_djd {
    width: max-content;
    height: 42px;
    border: 1px solid rgba(145, 50, 47, 0.18);
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 0 7px;
    margin: 28px auto 0;
  }
  .top_button_djd_A {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #1b2336;
    cursor: pointer;
    border-radius: 30px;
    height: 32px;
    width: max-content;
    line-height: 32px;
    padding: 0 20px;
    margin-right: 10px;
  }

  .jcdjB {
    color: #100043;
    font-size: 14px;
    text-align: left;
    margin-top: 4px;
    font-weight: 400;
    font-family: SourceHanSansCN-Regular;
  }
  .jcdjC {
    color: #6327d3;
    font-size: 14px;
    text-align: left;
    margin-top: 4px;
    font-weight: 400;
    font-family: SourceHanSansCN-Regular;
  }
  .div_jiajian_butt_text_B {
    height: 16px;
    background: #edf3fc;
    border-radius: 2px;
    border: 1px solid #6327d3;
    display: inline-block;
    padding: 0 5px;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    color: #6327d3;
    width: max-content;
    line-height: 16px;
    transform: translateY(-4px);
    margin-left: 10px;
  }
  .div_jiajian_butt_text_C {
    transition: 0.4s;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    width: 300px;
    text-transform: uppercase;
    margin-bottom: 31px;
  }
  .edcz_butt {
    width: 120px;
  }
  .cptc_butt {
    width: 120px;
  }
  .pay_main_body_divC_main {
    margin-bottom: 500px;
  }
  .pay_main_body_divC_main_div {
    width: 1400px;
    height: 200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .pay_main_body_divC_main_div_divA {
    width: 70%;
    height: 100%;
  }
  .pay_main_body_divC_main_div_divB {
    width: 30%;
    height: 100%;
  }
  .pay_main_body_divC_main_div_divA_div_div_input {
    display: flex;
    justify-content: space-between;
  }
  .pay_main_body_divC_main_div_divA_div_div_input_div {
    display: flex;
    justify-content: left;
  }
  .package-container {
    margin-top: 20px;
  }

  .package-button {
    margin: 10px;
    background: none; /* 无背景颜色 */
    border: none; /* 无边框 */
    padding: 10px 20px; /* 按钮内边距 */
    font-size: 19px; /* 字体大小 */
    font-weight: 600;
    cursor: pointer; /* 鼠标悬浮时显示为手型 */
    transition: color 0.3s ease; /* 文字颜色变化的过渡效果 */
    color: #0d0c3b;
  }

  .package-button:hover {
    color: #6327d3; /* 鼠标悬浮时的文字颜色 */
  }

  .package-button.active {
    color: #6327d3; /* 选中时的文字颜色 */
  }

  .shadow {
    width: 100%; /* 阴影宽度 */
    height: 5px; /* 阴影高度 */
    background: rgba(0, 0, 0, 0.2); /* 阴影颜色 */
    margin-top: 10px; /* 阴影与按钮的间距 */
  }

  .pay_main_body_divB_H1 {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 40px;
    color: #1b2336;
    line-height: 44px;
    width: max-content;
    margin: 0 auto;
    position: relative;
    margin-bottom: 50px;
  }
  .pay_main_body_divB_divs_link {
    display: flex;
    justify-content: space-around;
    width: 700px;
    margin: 0 auto;
  }
  .solut_divB1 {
    margin-top: 70px;
  }
  .solut_divB1_img_div {
    display: flex;
    justify-content: space-around;
    width: 1400px;
    margin: 0 auto;
  }
  .solut_divB1_img_div_div {
  }
  .solut_divB1_img_div_div > div:nth-child(1) {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 27px;
    color: #20232a;
    line-height: 35px;
    margin-bottom: 29px;
    margin-top: 30px;
    text-align: left;
  }
  .solut_divB1_img_div_div > div:nth-child(2) {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #585d69;
    line-height: 32px;
    width: 560px;
    text-align: left;
  }
  .solut_divB1_img_div_div > div:nth-child(3) {
    margin-top: 76px;
    width: 170px;
    height: 48px;
    background: #1a73e8;
    border-radius: 50px;
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #edf3fc;
    text-align: center;
    line-height: 48px;
    display: block;
  }
  .div_3 {
    margin-top: 200px;
  }
  .H2 {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 40px;
    color: #1b2336;
    text-align: center;
  }
  .H3 {
    font-weight: 400;
    font-size: 18px;
    color: #565656;
    text-align: center;
    margin-top: 29px;
  }
  .gj_img {
    display: flex;
    justify-content: center;
    width: 300px;
    margin: 15px;
  }
  .gj_img > img {
    width: 58px;
    height: 58px;
    margin-right: 20px;
  }
  .gj_img_H1 {
    text-align: left;
    font-weight: 400;
    font-size: 18px;
    color: #707070;
  }
  .gj_img_H2 {
    text-align: left;
    font-family: SourceHanSansCN-Medium;
    font-size: 21px;
    color: #242331;
  }
  .num_gj > div {
    margin: 60px;
    display: flex;
    justify-content: center;
  }
  .solut_div_A1 {
    margin-top: 200px;
  }
  .sulutions_divA {
    display: flex;
    justify-content: space-around;
    width: 1400px;
    margin: 0 auto;
  }
  .sulutions_divA_div_H {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 54px;
    color: #0e0b3d;
    text-align: left;
  }
  .sulutions_divA_div_text {
    width: 600px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 18px;
    color: rgba(18, 17, 39, 0.72);
    line-height: 30px;
    margin-top: 14px;
    margin-bottom: 36px;
    text-align: left;
  }
  .sulutions_divA_div_divS {
    margin: 20px 0 50px 0;
  }
  .sulutions_divA_div_divS > div {
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #444e72;
    text-align: left;
    margin-top: 20px;
  }
  .sulutions_divA_div_but_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #6a7f9d;
    margin-top: 39px;
    text-align: left;
  }
  .sulutions_divA_div_butts {
    display: flex;
    justify-content: space-around;
  }
  .solu_butt_divA {
    width: 191px;
    height: 54px;
    color: #edf3fc;
    background-color: #3580ff;
    border-radius: 36px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    cursor: pointer;
  }
  .solu_butt_divB {
    width: 191px;
    height: 54px;
    border-radius: 36px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    cursor: pointer;
    border: 1px solid #000;
  }
  .sulutions_divB {
    margin-top: 200px;
  }
  .sulutions_divB_div_div_B {
    width: 1400px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
  }
  .sulutions_div_top {
    display: flex;
    justify-content: center;
  }
  .sulutions_divB_div_div_div {
    width: 433px;
    height: 322px;
  }
  .sulutions_divB_div_div_div_H {
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    color: #2f2f2f;
    margin: 14px 0 17px;
  }
  .sulutions_divB_div_div_div_text {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 16px;
    color: grey;
    line-height: 24px;
    text-align: center;
    width: 350px;
    margin: 0 auto;
  }
  .sulutions_divB_div_div_H {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 40px;
    color: #1b2336;
    line-height: 44px;
    width: max-content;
    margin: 0 auto;
    position: relative;
    margin-bottom: 150px;
  }
  .sulutions_divB_div_div_div_img > img {
    width: 74px;
    height: 74px;
  }
  .div_div_butss {
    width: 173px;
    height: 55px;
    border-radius: 12px;
    border: 1px solid #3c71ee;
    cursor: pointer;
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #0c4ce1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 56px;
  }
  .sulutions_divC {
    display: flex;
    justify-content: center;
  }
  .sulutions_divC > div {
    width: 1200px;
    display: flex;
    justify-content: center;
  }
  .sulutions_divC_div {
    width: 50%;
  }
  .sulutions_divC_div_img {
    width: 50%;
  }
  .sulutions_divC_div_H {
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
    font-size: 38px;
    color: #202020;
    line-height: 55px;
    margin-bottom: 21px;
    text-align: left;
    margin-top: 150px;
  }
  .sulutions_divC_div_text {
    text-align: left;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #565656;
    line-height: 26px;
    width: 650px;
  }
  .sulutions_divC_div_i {
    display: flex;
    justify-content: space-around;
    font-family: SourceHanSansCN-Regular;
    font-weight: 500;
    font-size: 16px;
    color: #292626;
    display: flex;
    align-items: center;
    min-width: 225px;
    width: 400px;
    margin-bottom: 20px;
    margin-top: 80px;
  }
  .el-icon-check {
    font-size: 22px;
    margin-top: 10px;
  }
  .sulutions_divC_div_i_div > div {
    text-align: left;
  }
  .sulutions_divD {
    margin-top: 200px;
  }
  .sulutions_divD_div {
    display: flex;
    justify-content: space-around;
    width: 1400px;
    margin: 0 auto;
  }
  .sulutions_divD_divs{
      margin-top: 70px;
  }
  .sulutions_divD_divs > div:nth-child(1) {
      font-family: SourceHanSansCN-Medium;
      font-weight: 400;
      font-size: 38px;
      color: #202020;
      line-height: 55px;
      margin-bottom: 21px;
      text-align: left;
  }
  .sulutions_divD_divs > div:nth-child(2) {
      width: 630px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 18px;
      color: #565656;
      line-height: 26px;
      text-align: left;
  }
  .sulutions_divD_divs > div:nth-child(3) {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 18px;
      color: #565656;
      line-height: 26px;
      text-align: left;
      width: 630px;
      margin-top: 30px;
  }
  .sulutions_divD_divs > div:nth-child(4) {
  }
  </style>


